/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";
import { modifier } from "ember-modifier";
import jQuery from "jquery";
let FuiDropdownComponent = (_class = class FuiDropdownComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "valuesMap", new Map());
    _defineProperty(this, "triggerChange", modifier(this._triggerChange));
  }
  _triggerChange(e) {
    // We need to call this property so that ember-modifier can execute the function when it is updated
    /* eslint-disable-next-line @typescript-eslint/no-unused-expressions */
    this.args.selected;
    jQuery(e).data().moduleDropdown.trigger.change();
  }
  registerValue(value) {
    this.valuesMap.set(value, this.valueMapper(value));
  }
  valueMapper(value) {
    if (value instanceof Array) {
      return value.map(i => {
        return typeof i === "string" ? i : guidFor(i);
      }).join(",");
    }
    return typeof value === "string" ? value : guidFor(value);
  }
  get selected() {
    return this.valueMapper(this.args.selected);
  }
  get initialOnChange() {
    if (!this.args.settings) return undefined;
    return this.args.settings.onChange;
  }
  get settings() {
    const newOnChangeSetting = {};
    if (this.onChangeFromGuid) newOnChangeSetting.onChange = this.onChangeFromGuid;

    // replace the `onChange` provided in the @settings argument with the same method,
    // but this new one receives a Guid instead
    return Object.assign({}, this.args.settings, newOnChangeSetting);
  }
  get onChangeFromGuid() {
    if (!this.initialOnChange) return undefined;
    const initialOnChange = this.initialOnChange;
    return guid => {
      const newValue = this.getValueFromGuid(guid);
      if (!newValue) {
        console.log(`No value found for guid ${guid}`);
        return;
      }
      initialOnChange(newValue);
    };
  }
  getValueFromGuid(guid) {
    const guidAsArr = guid.split(",");
    const tuple = [...this.valuesMap].find(t => guidAsArr.find(guid => guid === t[1]));
    if (!tuple) return undefined;
    return tuple[0];
  }
}, _applyDecoratedDescriptor(_class.prototype, "_triggerChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_triggerChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerValue"), _class.prototype), _class);
export { FuiDropdownComponent as default };